import { useState, useEffect } from "react";
import { Utensils } from "lucide-react";
import Layout from "@/components/layout/Layout";
import PageHero from "@/components/shared/PageHero";
import { DestinationCard, DestinationCardSkeleton } from "@/components/shared/DestinationCard";
import axios from "axios";
import { API } from "@/App";

export default function SaboresPage() {
  const [flavors, setFlavors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFlavors = async () => {
      try {
        const response = await axios.get(`${API}/public/flavors?limit=20`);
        setFlavors(response.data.items);
      } catch (error) {
        console.error("Error fetching flavors:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchFlavors();
  }, []);

  return (
    <Layout>
      {/* Hero */}
      <PageHero
        section="sabores"
        title="Sabores"
        subtitle="Descubre la deliciosa gastronomía hondureña. Platillos tradicionales, recetas ancestrales y sabores únicos."
        badge="Gastronomía"
        badgeIcon={Utensils}
      />

      {/* Grid */}
      <section className="py-12 md:py-16" data-testid="flavors-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3, 4, 5, 6].map((i) => <DestinationCardSkeleton key={i} />)}
            </div>
          ) : flavors.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {flavors.map((post) => (
                <DestinationCard key={post.post_id} post={{ ...post, post_type: "flavor" }} />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <Utensils className="h-12 w-12 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500">No hay sabores publicados aún</p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
